import styled from 'styled-components'
import { UsersTable } from '../ServiceManagement/styles'

export const Filters = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 12px;

	select {
		height: 40px;
		padding: 0 12px;
		border-radius: 6px;
		border: 1px solid #dda8a8;
		background-color: #fff9f9;
		color: #222222;
		font-size: 14px;
	}

	button {
		height: 40px;
		padding: 0 18px;
		border-radius: 6px;
		border: none;
		background-color: #f78b85;
		color: #ffffff;
		font-weight: 600;
		letter-spacing: -0.5px;
		cursor: pointer;
		transition: background-color 0.2s ease;

		&:hover {
			background-color: #e3756f;
		}

		&:disabled {
			background-color: #eabfbd;
			cursor: not-allowed;
		}
	}
`

export const DeviceTable = styled(UsersTable)`
	min-width: 860px;

	th,
	td {
		text-align: left;
	}

	th:nth-child(1) {
		width: 12%;
	}
	th:nth-child(2) {
		width: 20%;
	}
	th:nth-child(3) {
		width: 20%;
	}
	th:nth-child(4) {
		width: 15%;
	}
	th:nth-child(5) {
		width: 15%;
	}
	th:nth-child(6) {
		width: 10%;
	}
	th:nth-child(7) {
		width: 8%;
	}

	td .meta {
		display: flex;
		flex-direction: column;
		gap: 4px;
		color: #666666;
		font-size: 12px;
	}

	td .token {
		font-family: 'Pretendard-Regular', monospace;
		font-size: 11px;
		color: #a07c7c;
		overflow-wrap: anywhere;
	}
`

export const SessionActions = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;

	button {
		min-width: 90px;
		height: 32px;
		padding: 0 14px;
		border-radius: 6px;
		border: 1px solid #e5d0d0;
		background-color: #ffffff;
		color: #d3490d;
		cursor: pointer;
		transition: all 0.2s ease;

		&:hover:not(:disabled) {
			background-color: #fae7e7;
			color: #a52a2a;
		}

		&:disabled {
			cursor: not-allowed;
			opacity: 0.6;
		}
	}
`

export const ActivityText = styled.span`
	display: block;
	font-size: 13px;
	color: #222222;
`

export const SubText = styled.span`
	display: block;
	font-size: 12px;
	color: #8a8a8a;
`

export const ServiceChip = styled.span<{ $service: 'goms' | 'want' }>`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 4px 10px;
	border-radius: 999px;
	font-size: 12px;
	font-weight: 600;
	text-transform: uppercase;
	background-color: ${({ $service }) => ($service === 'goms' ? '#daf5e5' : '#e4ecff')};
	color: ${({ $service }) => ($service === 'goms' ? '#056b2e' : '#2d4fa1')};
`
